import { FC, useCallback } from "react";

import Grid from "@mui/material/Grid";

import { AmplitudeEvents } from "../../constants/amplitude";
import { DropdownButton, DropdownButtonProps } from "../DropdownButton/DropdownButton";

import { useStyles } from "./useStyles";

import { DashboardButton, DashboardButtonProps } from "@/dashboard-design-system/Button";
import { DashboardDrawer } from "@/dashboard-design-system/Drawer";
import { DashboardTooltipProps } from "@/dashboard-design-system/Tooltip";

type MoreDrawerButtonProps = Omit<DashboardButtonProps, "color" | "variant" | "fullWidth" | "className" | "size">;

export interface CTAProps extends MoreDrawerButtonProps {
  dropdownButtonOptions?: DropdownButtonProps["menuItemsProps"];
  buttonText?: DropdownButtonProps["buttonText"];
  amplitudeEventOnClick?: AmplitudeEvents;
  tooltipProps?: Pick<DashboardTooltipProps, "title" | "placement">;
}

interface MoreButtonsDrawerProps {
  title: string;
  buttons: CTAProps[];
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
}

export const MoreButtonsDrawer: FC<MoreButtonsDrawerProps> = ({
  title,
  buttons,
  isOpen,
  setIsOpen,
}: MoreButtonsDrawerProps) => {
  const classes = useStyles();
  const onClose = useCallback(() => {
    setIsOpen(false);
  }, [setIsOpen]);

  return (
    <DashboardDrawer onClose={onClose} open={isOpen} size="medium" anchor="bottom" title={title}>
      {buttons.map((CTA, index) => {
        const { children, dropdownButtonOptions, buttonText: dropdownButtonLabel, ...rest } = CTA;

        if (dropdownButtonOptions && dropdownButtonLabel) {
          return (
            <Grid item key={index}>
              <DropdownButton
                size="medium"
                variant="text"
                vibe="neutral"
                buttonText={dropdownButtonLabel}
                menuItemsProps={dropdownButtonOptions}
                isMobileLayout
                amplitudeEventOnClick={rest.amplitudeEventOnClick}
              />
            </Grid>
          );
        }

        return (
          <Grid key={index}>
            <DashboardButton {...rest} variant="text" vibe="neutral" fullWidth className={classes.alignText}>
              {children}
            </DashboardButton>
          </Grid>
        );
      })}
    </DashboardDrawer>
  );
};
